import React from 'react';
import { Link } from 'react-router-dom';
import './InternshipCardSimple.css';

interface InternshipCardSimpleProps {
    internship: {
        id: string;
        company: string;
        position: string;
        period: string;
        location: string;
        logo: string;
        description: string;
        workContent: { [key: string]: string[] };
        skills: string[];
    };
}

const InternshipCardSimple: React.FC<InternshipCardSimpleProps> = ({ internship }) => {

    return (
        <div className="internship-card-simple">
            <div className="card-header">
                <div className="company-logo">
                    <img src={internship.logo} alt={internship.company} />
                </div>
                <div className="company-info">
                    <h3 className="company-name">{internship.company}</h3>
                    <p className="position">{internship.position}</p>
                    <div className="meta-info">
                        <span className="period">{internship.period}</span>
                        <span className="location">{internship.location}</span>
                    </div>
                </div>
            </div>

            <div className="card-content">
                <p className="description">{internship.description}</p>

                <div className="skills">
                    {internship.skills.slice(0, 3).map((skill, index) => (
                        <span key={index} className="skill-tag">
                            {skill}
                        </span>
                    ))}
                    {internship.skills.length > 3 && (
                        <span className="skill-more">+{internship.skills.length - 3}</span>
                    )}
                </div>
            </div>

            <div className="card-footer">
                <Link
                    to={`/internships/${internship.id}`}
                    className="btn btn-outline"
                >
                    了解更多
                </Link>
            </div>
        </div>
    );
};

export default InternshipCardSimple;
